import React from "react";
import PropTypes from "prop-types";

import { gql } from "@apollo/client";
import { Mutation } from "@apollo/client/react/components";

import { OrderObject } from "./../Queries/OrderQuery";
import orderFragments from "./../Queries/graphql/orderFragments";
import orderEventFragments from "./../Queries/graphql/orderEventFragments";

const UPDATE_ORDER = gql`
  mutation backToValidation($id: ID!) {
    backToValidation(id: $id) {
      order {
        ...OrderFields
        events {
          ...EventQuery
        }
      }
      errors {
        path
        message
      }
    }
  }
  ${orderFragments.query}
  ${orderEventFragments.query}
`;

class BackToValidationUpdater extends React.Component {
  state = { errors: null };
  render() {
    const { order, render } = this.props;
    return (
      <Mutation mutation={UPDATE_ORDER} onError={this.onError}>
        {(update, { loading, error }) => {
          const backToValidation = () => {
            update({
              variables: {
                id: order.id
              }
            });
          };
          return render({ order, backToValidation });
        }}
      </Mutation>
    );
  }

  onError = error => {
    console.log("onError occurred");
    console.log(error);
  };
}

BackToValidationUpdater.propTypes = {
  order: OrderObject,
  render: PropTypes.func.isRequired
};

export default BackToValidationUpdater;
